import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import clsx from 'clsx';
import dynamic from 'next/dynamic';
import React, { useState } from 'react';
import useEditingAreasState from '@/components/Editor/hooks/useEditingAreasState';
import { ButtonV2 as Button } from '@/components/Button';
import GuideCard from '@/components/misc/GuideCard';
import Spreadsheet from '@/components/Spreadsheet';
import Accordion, { AccordionPanel } from '@/components/Accordion';
import Header from '@/components/Editor/modals/Header';
import Footer from '@/components/Editor/modals/Footer';
import useHighlights from '../useHighlights';
import SelectionsList from '../SelectionsList';
import CollectionsList from './CollectionsList';
import displayModalStyles from '@/components/ModalHoc/stylesDisplay.module.scss';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var PlusSquareIcon = function PlusSquareIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 7C12.5523 7 13 7.44772 13 8V11H16C16.5523 11 17 11.4477 17 12C17 12.5523 16.5523 13 16 13H13V16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16V13H8C7.44772 13 7 12.5523 7 12C7 11.4477 7.44772 11 8 11H11V8C11 7.44772 11.4477 7 12 7Z",
      fill: "#12131A"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.3572 3H13.6428C14.7266 2.99999 15.6007 2.99998 16.3086 3.05782C17.0375 3.11737 17.6777 3.24318 18.27 3.54497C19.2108 4.02433 19.9757 4.78924 20.455 5.73005C20.7568 6.32234 20.8826 6.96253 20.9422 7.69138C21 8.39925 21 9.27339 21 10.3572V13.6428C21 14.7266 21 15.6008 20.9422 16.3086C20.8826 17.0375 20.7568 17.6777 20.455 18.27C19.9757 19.2108 19.2108 19.9757 18.27 20.455C17.6777 20.7568 17.0375 20.8826 16.3086 20.9422C15.6008 21 14.7266 21 13.6428 21H10.3572C9.27339 21 8.39925 21 7.69138 20.9422C6.96253 20.8826 6.32234 20.7568 5.73005 20.455C4.78924 19.9757 4.02433 19.2108 3.54497 18.27C3.24318 17.6777 3.11737 17.0375 3.05782 16.3086C2.99998 15.6007 2.99999 14.7266 3 13.6428V10.3572C2.99999 9.27341 2.99998 8.39926 3.05782 7.69138C3.11737 6.96253 3.24318 6.32234 3.54497 5.73005C4.02433 4.78924 4.78924 4.02433 5.73005 3.54497C6.32234 3.24318 6.96253 3.11737 7.69138 3.05782C8.39926 2.99998 9.27341 2.99999 10.3572 3ZM7.85424 5.05118C7.24907 5.10062 6.90138 5.19279 6.63803 5.32698C6.07354 5.6146 5.6146 6.07354 5.32698 6.63803C5.19279 6.90138 5.10062 7.24907 5.05118 7.85424C5.00078 8.47108 5 9.26339 5 10.4V13.6C5 14.7366 5.00078 15.5289 5.05118 16.1458C5.10062 16.7509 5.19279 17.0986 5.32698 17.362C5.6146 17.9265 6.07354 18.3854 6.63803 18.673C6.90138 18.8072 7.24907 18.8994 7.85424 18.9488C8.47108 18.9992 9.26339 19 10.4 19H13.6C14.7366 19 15.5289 18.9992 16.1458 18.9488C16.7509 18.8994 17.0986 18.8072 17.362 18.673C17.9265 18.3854 18.3854 17.9265 18.673 17.362C18.8072 17.0986 18.8994 16.7509 18.9488 16.1458C18.9992 15.5289 19 14.7366 19 13.6V10.4C19 9.26339 18.9992 8.47108 18.9488 7.85424C18.8994 7.24907 18.8072 6.90138 18.673 6.63803C18.3854 6.07354 17.9265 5.6146 17.362 5.32698C17.0986 5.19279 16.7509 5.10062 16.1458 5.05118C15.5289 5.00078 14.7366 5 13.6 5H10.4C9.26339 5 8.47108 5.00078 7.85424 5.05118Z",
      fill: "#12131A"
    })]
  }));
};

PlusSquareIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var NewWindowIcon = function NewWindowIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.33333 3.33333C4.22876 3.33333 3.33333 4.22876 3.33333 5.33333V10.6667C3.33333 11.7712 4.22876 12.6667 5.33333 12.6667H10.6667C11.7712 12.6667 12.6667 11.7712 12.6667 10.6667V8.66667C12.6667 8.29848 12.9651 8 13.3333 8C13.7015 8 14 8.29848 14 8.66667V10.6667C14 12.5076 12.5076 14 10.6667 14H5.33333C3.49238 14 2 12.5076 2 10.6667V5.33333C2 3.49238 3.49238 2 5.33333 2H7.33333C7.70152 2 8 2.29848 8 2.66667C8 3.03486 7.70152 3.33333 7.33333 3.33333H5.33333Z",
      fill: "#12131A"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.6667 5.33333C12.6667 5.70152 12.9651 6 13.3333 6C13.7015 6 14 5.70152 14 5.33333V2.66667C14 2.29848 13.7015 2 13.3333 2H10.6667C10.2985 2 10 2.29848 10 2.66667C10 3.03486 10.2985 3.33333 10.6667 3.33333L11.7239 3.33333L7.33333 7.72386V6.66667C7.33333 6.29848 7.03486 6 6.66667 6C6.29848 6 6 6.29848 6 6.66667V9.33333C6 9.70152 6.29848 10 6.66667 10H9.33333C9.70152 10 10 9.70152 10 9.33333C10 8.96514 9.70152 8.66667 9.33333 8.66667H8.27614L12.6667 4.27614V5.33333Z",
      fill: "#12131A"
    })]
  }));
};

NewWindowIcon.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var CloseIcon = function CloseIcon(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M17.1548 0.488155C17.8057 -0.162718 18.861 -0.162718 19.5118 0.488155C20.1627 1.13903 20.1627 2.1943 19.5118 2.84518L12.357 10L19.5118 17.1548C20.1627 17.8057 20.1627 18.861 19.5118 19.5118C18.861 20.1627 17.8057 20.1627 17.1548 19.5118L10 12.357L2.84518 19.5118C2.1943 20.1627 1.13903 20.1627 0.488156 19.5118C-0.162719 18.861 -0.162719 17.8057 0.488156 17.1548L7.64298 10L0.488156 2.84518C-0.162718 2.1943 -0.162718 1.13903 0.488156 0.488155C1.13903 -0.162718 2.19431 -0.162718 2.84518 0.488155L10 7.64298L17.1548 0.488155Z",
      fill: "#BABDCC"
    })
  }));
};

CloseIcon.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const Preview = dynamic(() => import('@/components/Editor/Preview'), {
  ssr: false,
  loadableGenerated: {
    webpack: () => [require.resolveWeak('@/components/Editor/Preview')]
  }
});
const DEFAULT_PREVIEW_RESOLUTION = {
  id: 'custom',
  value: [416, 416],
  label: 'Custom'
};

const SelectionsV2 = _ref => {
  var _controls$selectionGu;

  let {
    containerRef,
    workbook,
    previewWidget,
    reportingWidget,
    workbookMeta,
    gridSelections,
    highlightColors,
    labelsSelectionsSupported,
    legendsSelectionsSupported,
    labelsSelections,
    legendsSelections,
    activeLabelsSelectionCellRef,
    activeLegendsSelectionCellRef,
    selectionsStrategy,
    selectionCollections,
    invalidSelectionCollections,
    updatedAt,
    sheetNames,
    activeSelectionsType: initialSelectionsType,
    activeSpreadsheet,
    activeSelection,
    activeCollection,
    activeSelectionCellRef,
    isAddingNewSelection,
    controls = {},
    isTwoColLayout,
    isLoading,
    onSubmit,
    onAddCollection,
    onChangeSelection,
    onChangeLabelsSelection,
    onChangeLegendsSelection,
    onSelectSelection,
    onSelectCollection,
    onSelectSpreadsheet,
    onResetActiveSelection,
    onRemoveSelection,
    onRemoveCollection,
    onSpreadsheetError,
    onSpreadsheetWarn,
    onChangeAddMode
  } = _ref;
  const {
    textOverrides = {}
  } = controls;
  const selectionTextOverrides = textOverrides[selectionsStrategy] || textOverrides.default || '';
  const selectionGuides = ((_controls$selectionGu = controls.selectionGuides) === null || _controls$selectionGu === void 0 ? void 0 : _controls$selectionGu[selectionsStrategy]) || {};
  const maxSelections = controls.maxSelections[selectionsStrategy];
  const maxCollections = controls.multiCollectionMaximums[selectionsStrategy] ?? Infinity;
  const isMaxCollectionsReached = selectionCollections.length >= maxCollections;
  const isAllCollectionsFilled = selectionCollections.every(collection => collection.length > 0);
  const {
    activeSectionId
  } = useEditingAreasState();
  const {
    0: isPreviewOpen,
    1: setIsPreviewOpen
  } = useState(true);
  const {
    0: activeSelectionsType,
    1: setActiveSelectionsType
  } = useState(initialSelectionsType || 'values'); // Determine if the active selections type is labels or legends

  const hasHeaderSelections = Boolean(initialSelectionsType) && initialSelectionsType !== 'values';
  const isLabelsSelections = !hasHeaderSelections || initialSelectionsType === 'labels';
  const isLegendsSelections = !hasHeaderSelections || initialSelectionsType === 'legends'; // Determine the active selections and cell ref based on the active selections type

  const headerConfig = {
    labels: {
      selections: labelsSelections,
      activeCellRef: activeLabelsSelectionCellRef
    },
    legends: {
      selections: legendsSelections,
      activeCellRef: activeLegendsSelectionCellRef
    }
  }[activeSelectionsType] || {}; // Get the active selections and highlight colors based on the active selections type

  const {
    selections: gridHeaderSelections,
    colors: highlightHeaderColors
  } = useHighlights([headerConfig.selections || []], 0, 0, false, 1);
  const activeGridSelections = activeSelectionsType !== 'values' ? gridHeaderSelections : gridSelections;
  const activeCellRef = activeSelectionsType !== 'values' ? headerConfig.activeCellRef : activeSelectionCellRef;

  const handleChangeSelection = cellRefs => {
    if (activeSelectionsType === 'labels') {
      onChangeLabelsSelection(cellRefs);
    } else if (activeSelectionsType === 'legends') {
      onChangeLegendsSelection(cellRefs);
    } else {
      onChangeSelection(cellRefs);
    }
  };

  const handleChangeSelectionsType = selectionsType => {
    setActiveSelectionsType(selectionsType);

    if (selectionsType === 'values') {
      onResetActiveSelection();
    }
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Header, {
      heading: "Selections",
      className: "-p-none"
    }), /*#__PURE__*/_jsxs("div", {
      ref: containerRef,
      className: clsx(displayModalStyles.container, styles.container, {
        [styles['container--twoCols']]: isTwoColLayout,
        [displayModalStyles['container--twoCols']]: isTwoColLayout
      }),
      children: [/*#__PURE__*/_jsx("aside", {
        className: clsx(styles.sidebar, {
          [styles['sidebar--large']]: !isTwoColLayout
        }),
        children: /*#__PURE__*/_jsx("div", {
          className: clsx(styles.sidebarMain),
          children: /*#__PURE__*/_jsxs(Accordion, {
            className: styles.accordion,
            children: [labelsSelectionsSupported && isLabelsSelections ? /*#__PURE__*/_jsxs(AccordionPanel, {
              title: "Labels",
              isOpen: activeSelectionsType === 'labels',
              isIndicatorHidden: true,
              caption: "Customize where sections' label data comes from",
              className: styles.panel,
              classes: {
                content: styles.panel__content,
                heading: styles.panel__heading,
                isOpen: styles['panel--isOpen']
              },
              onClick: () => handleChangeSelectionsType('labels'),
              children: [selectionGuides !== null && selectionGuides !== void 0 && selectionGuides.labelSelection ? /*#__PURE__*/_jsx(GuideCard, {
                image: selectionGuides === null || selectionGuides === void 0 ? void 0 : selectionGuides.labelSelection,
                className: styles.guideCard
              }) : /*#__PURE__*/_jsx(_Fragment, {}), /*#__PURE__*/_jsx(SelectionsList, {
                selections: labelsSelections,
                invalidSelections: invalidSelectionCollections[0],
                highlightColors: highlightHeaderColors,
                maxSelections: 1 // Allow only one selection for labels
                ,
                activeSelection: 0,
                collectionIndex: 0,
                sheetNames: sheetNames,
                isAdding: labelsSelections.length === 0
              })]
            }) : /*#__PURE__*/_jsx(_Fragment, {}), legendsSelectionsSupported && isLegendsSelections ? /*#__PURE__*/_jsxs(AccordionPanel, {
              title: "Legends",
              isOpen: activeSelectionsType === 'legends',
              isIndicatorHidden: true,
              caption: "Select content to populate the legend of the chart",
              className: styles.panel,
              classes: {
                content: styles.panel__content,
                heading: styles.panel__heading,
                isOpen: styles['panel--isOpen']
              },
              onClick: () => handleChangeSelectionsType('legends'),
              children: [selectionGuides !== null && selectionGuides !== void 0 && selectionGuides.legendSelection ? /*#__PURE__*/_jsx(GuideCard, {
                image: selectionGuides === null || selectionGuides === void 0 ? void 0 : selectionGuides.legendSelection,
                className: styles.guideCard
              }) : /*#__PURE__*/_jsx(_Fragment, {}), /*#__PURE__*/_jsx(SelectionsList, {
                selections: legendsSelections,
                invalidSelections: invalidSelectionCollections[0],
                highlightColors: highlightHeaderColors,
                maxSelections: 1 // Allow only one selection for legends
                ,
                activeSelection: 0,
                collectionIndex: 0,
                sheetNames: sheetNames,
                isAdding: legendsSelections.length === 0
              })]
            }) : /*#__PURE__*/_jsx(_Fragment, {}), /*#__PURE__*/_jsxs(AccordionPanel, {
              title: "Values",
              isOpen: activeSelectionsType === 'values',
              isIndicatorHidden: true,
              caption: "Customize where sections' value data comes from, visually changing what's presented to users.",
              className: styles.panel,
              classes: {
                content: styles.panel__content,
                heading: styles.panel__heading,
                isOpen: styles['panel--isOpen']
              },
              onClick: () => handleChangeSelectionsType('values'),
              children: [selectionGuides !== null && selectionGuides !== void 0 && selectionGuides.valueSelection ? /*#__PURE__*/_jsx(GuideCard, {
                image: selectionGuides === null || selectionGuides === void 0 ? void 0 : selectionGuides.valueSelection,
                className: styles.guideCard
              }) : /*#__PURE__*/_jsx(_Fragment, {}), /*#__PURE__*/_jsx(CollectionsList, {
                collections: selectionCollections,
                invalids: invalidSelectionCollections,
                activeCollection: activeCollection,
                activeSelection: activeSelection,
                highlightColors: highlightColors,
                isAdding: isAddingNewSelection,
                maxSelections: maxSelections,
                textOverrides: {
                  deleteCollectionButton: selectionTextOverrides.deleteCollectionButton,
                  groupTitle: selectionTextOverrides.collectionGroupTitle
                },
                onRemoveSelection: (collectionIndex, selectionIndex) => {
                  onRemoveSelection(collectionIndex, selectionIndex);
                },
                onRemoveCollection: index => onRemoveCollection(index),
                onActivateCollection: index => onSelectCollection(index),
                onActivateSelection: onSelectSelection,
                onChangeAddMode: onChangeAddMode
              }), !isMaxCollectionsReached && isAllCollectionsFilled ? /*#__PURE__*/_jsx(Button, {
                variant: "dark",
                size: "large",
                onClick: onAddCollection,
                className: "w-full",
                leftIcon: /*#__PURE__*/_jsx(PlusSquareIcon, {}),
                children: selectionTextOverrides.addCollectionButton || 'Add Group'
              }) : /*#__PURE__*/_jsx(_Fragment, {})]
            }), !isPreviewOpen ? /*#__PURE__*/_jsx("div", {
              className: styles.previewPanel,
              children: /*#__PURE__*/_jsx(Button, {
                type: "button",
                size: "large",
                leftIcon: /*#__PURE__*/_jsx(NewWindowIcon, {}),
                className: styles.previewButton,
                onClick: () => setIsPreviewOpen(true),
                children: "Open Preview"
              })
            }) : /*#__PURE__*/_jsx(_Fragment, {})]
          })
        })
      }), /*#__PURE__*/_jsx("section", {
        className: displayModalStyles.main,
        children: /*#__PURE__*/_jsxs("div", {
          className: clsx(styles.spreadsheet, isTwoColLayout ? styles['spreadsheet--large'] : ''),
          children: [isLoading ? /*#__PURE__*/_jsx(_Fragment, {}) : /*#__PURE__*/_jsx(Spreadsheet, {
            data: workbook,
            meta: workbookMeta,
            selections: activeGridSelections,
            activeSelection: activeCellRef,
            activeSheetIndex: activeSpreadsheet,
            editable: false,
            addingNewSelection: isAddingNewSelection && activeSelectionsType === 'values',
            onSelect: handleChangeSelection,
            onSheetChange: onSelectSpreadsheet,
            onSelectionClick: (_, details) => {
              if (details) {
                const isNewCollection = details.collectionIndex !== activeCollection;
                onSelectCollection(details.collectionIndex);
                onSelectSelection(details.selectionIndex, isNewCollection);
              }
            },
            onError: onSpreadsheetError,
            onWarn: onSpreadsheetWarn
          }), isPreviewOpen ? /*#__PURE__*/_jsxs("div", {
            className: styles.floatingPreview,
            children: [/*#__PURE__*/_jsx(Preview, {
              elementId: "labels-selections-widget-preview",
              className: styles.preview,
              widget: previewWidget,
              initialResolutionStrategy: "custom",
              reportingWidget: reportingWidget,
              focusedSectionId: activeSectionId,
              workbookFile: workbook,
              workbookMeta: workbookMeta,
              defaultZoomLevel: 45,
              isResolutionControlHidden: true,
              isResolutionGroupControlHidden: true,
              isPreviewContainerCollapsed: false,
              isZoomControlHidden: true,
              isScrollable: false,
              defaultPreviewResolution: DEFAULT_PREVIEW_RESOLUTION,
              editing: false,
              updatedAt: updatedAt
            }), /*#__PURE__*/_jsx(Button, {
              leftIcon: /*#__PURE__*/_jsx(CloseIcon, {}),
              className: styles.floatingPreviewClose,
              size: "small",
              variant: "text",
              onClick: () => setIsPreviewOpen(false)
            })]
          }) : null]
        })
      })]
    }), /*#__PURE__*/_jsx(Footer, {
      actions: /*#__PURE__*/_jsx(Button, {
        type: "button",
        variant: "primary",
        onClick: onSubmit,
        children: "Save Updates"
      })
    })]
  });
};

export default SelectionsV2;